import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "radio"]

  connect() {
    setTimeout(() => this.updateButtonState(), 100)
  }

  selectRole(event) {
    this.updateButtonState()
  }

  submit(event) {
    event.preventDefault()
    const selectedRadio = this.radioTargets.find((radio) => radio.checked)
    if (selectedRadio) {
      window.location = selectedRadio.dataset.path
    }
  }

  updateButtonState() {
    const isAnySelected = this.radioTargets.some((radio) => radio.checked)
    this.buttonTarget.disabled = !isAnySelected
  }
}
